import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.ADS.LIST_ALL.REFRESH, () => {
  const requestId = `listAllAds-${Date.now()}`;
  bus.emit(constants.EVENTS.ADS.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.ADS.GET_LIST}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.ADS.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.ADS.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.ADS.UPDATE, saveAd);
bus.on(constants.EVENTS.ADS.SUBMIT, saveAd);
bus.on(constants.EVENTS.ADS.DELETE, (data) => saveAd({ ...data, action: 'delete' }));

async function saveAd(data) {
  const requestId = `saveAd-${Date.now()}`;
  const store = getStore('ads');
  const oldAds = store.state.list_all.list;

  bus.emit(constants.EVENTS.LOADING.START);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.ADS.UPDATE}`,
    method: 'POST',
    data: serializer.serialize(data, oldAds)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      bus.emit(constants.EVENTS.LOADING.FINISH);
      if (parsed.success) {
        bus.emit(constants.EVENTS.ADS.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.ADS.LIST_ALL.REFRESH, parsed.data);
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Echec de sauvegarde',
          body: parsed.message
        });
        bus.emit(constants.EVENTS.ADS.UPDATED, parsed);
        bus.emit(constants.EVENTS.ADS.LIST_ALL.REFRESH, parsed);
      }
    }
  });
}
